import COLOR from './COLOR.js'
import GRADIENT from './GRADIENT.js'
import THEME from './THEME.js'
import FONT from './FONT.js'
import FONT_FAMILY from './FONT_FAMILY.js'
import TYPOGRAPHY from './TYPOGRAPHY.js'
import SPACING from './SPACING.js'
import TIMING from './TIMING.js'
import CLASS from './CLASS.js'
import GRID from './GRID.js'
import ICONS from './ICONS.js'
import SHAPE from './SHAPE.js'
import RESET from './RESET.js'
import ANIMATION from './ANIMATION.js'
import MEDIA from './MEDIA.js'
import CASES from './CASES.js'

export default {
  COLOR,
  GRADIENT,
  THEME,
  FONT,
  FONT_FAMILY,
  TYPOGRAPHY,
  SPACING,
  TIMING,
  CLASS,
  GRID,
  ICONS,
  SHAPE,
  RESET,
  ANIMATION,
  MEDIA,
  CASES,
  useReset: true,
  useVariable: true,
  useFontImport: true,
  useIconSprite: true,
  useSvgSprite: true,
  useDefaultConfig: true,
  useDocumentTheme: true,
  verbose: false
}
